import logError from "seneca-common/utils/sentry/logError";

import { ROUTES } from "routing/routes";

import math from "./mathInstance";

export const EVALUATION_ERROR_STRING = "%error%";

export function evaluate(scope: any, statement: string) {
  try {
    return math.evaluate(applyWorkarounds(statement), scope);
  } catch (err) {
    if (scope._check) {
      /**
       *  if check(condition) was false at any point,
       *  than the script should be re-executed anyway (see generateScope() function)
       *  so the errors are expected and no need to log those
       */
      const inCreation = window.location.pathname.startsWith(
        ROUTES.CREATION.path
      );

      if (inCreation) {
        throw err;
      } else {
        logError(err, {
          message: "evaluate error"
        });
      }
    }
    return EVALUATION_ERROR_STRING;
  }
}

function applyWorkarounds(statement: string) {
  /**
   *  Setting the default `number` to `BigNumber` somehow made the built in `count` function to
   *  not work anymore, and this function cannot be overridden through config either, so this is a way
   *  to handle the issue without having to change all `count` occurrences in content.
   *  TODO: (When this is possible in the future) extend mathjs with custom `count` function
   *  */
  return statement.replaceAll("count(", "getCount(");
}
